/**
 * #823: window events a collab editor announces when the server ends its session — dependency-free, so a surface
 * that only LISTENS (the single-file window, a workspace tab) need not load the collab client.
 */

/** Announced when a room closes as moved to the bin (collab 4410) — `detail.room` (`<tenant>:<fileId>`). */
export const COLLAB_FILE_DELETED_EVENT = 'papan:collab-file-deleted'

/** Announced when the server refuses this editor's join or rejoin with 4403 — `detail.room`. The server gives a
 *  binned file and a withdrawn grant the same answer on purpose (#630); the surface holding the editor asks the file's
 *  detail again on a restore, and mounts a fresh editor once it answers as back. */
export const COLLAB_SESSION_REFUSED_EVENT = 'papan:collab-session-refused'

/** Announced by the editor HOST (EditorHost) when the editor it holds had its session ended — naming the host's own
 *  file and `hostKey`, never a room: a pointer's room is its target's and a workbook member's is its group's, so a
 *  room never identifies the surface. `reason`: 'deleted' (collab 4410 / office `oo-closed`) or 'refused' (4403). */
/**
 * #981: a whole-file room was refused because the file is a LARGE CSV (close 4413 `large_csv`) — `detail.room` is
 * the room. The surface holding that editor remounts the file in the large-CSV grid.
 */
export const COLLAB_LARGE_CSV_EVENT = 'papan:collab-large-csv'
export const EDITOR_SESSION_ENDED_EVENT = 'papan:editor-session-ended'
export interface EditorSessionEndedDetail {
  hostKey: string
  fileId: string
  reason: 'deleted' | 'refused'
}
